module.exports = __webpack_public_path__ + "img/1-D-characterisation_1.bacf079d.png";